<script setup>
import { reactive } from 'vue';
import { setScheduleFile, setDate, store } from '@/store';
import { formatDate } from '@/libraries/DateFunctions';
import { processScheduleFile, } from '../firebase_files/document_ai';

import SpinnerWheel from '@/components/SpinnerWheel.vue';

const props = defineProps(['doctor', 'type']);
const emits = defineEmits(['close']);

const state = reactive({
  isUploading: false,
  displayType: null,
  // for dev purposes is yyyy-mm-dd
  date:(new Date((new Date).getTime() - 4 * 60 * 60 * 1000)).toISOString().split('T')[0], //  adjusts for timezone, string splits

})

init();
function init() {
  if (props.type === 'upload') {
    state.displayType = 'Upload';
  } else if (props.type === 're-upload') {
    state.displayType = 'Re-Upload';
  }
}

/**
 * Secretary sends schedule to doctors firebase
 * @param {*} event 
 */
function onFileChange(event) {
  state.isUploading = true;
  store.aptDone = false; // aptDone is global and triggers 
  // const d = formatDate(state.date);
  setDate(state.date);
  const file = event.target.files[0];
  if (file) {
    setScheduleFile(file);
    processScheduleFile(props.doctor.uid);
  }
}


function closeModal() {
  emits('close');
}
</script>
<template>
  <div class="modal">
    <div class="modal-content" id="modal-container">
      <h1>{{ state.displayType }} for {{ doctor.name }}</h1>
      <input v-if="!state.isUploading" class='clinic-upload' type="file" @change="onFileChange($event)">
      <SpinnerWheel class='clinic-upload' v-if="state.isUploading"/>
      <button @click="closeModal">close</button>
    </div>

  </div>
</template>
<style scoped lang="scss">
#modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30%;
}
.clinic-upload{
  margin: 1rem;
}
</style>